import { toast as sonnerToast } from 'sonner';

type ToastMessage = Parameters<typeof sonnerToast>[0];
type ToastOptions = Parameters<typeof sonnerToast>[1];

const isReactElement = (value: unknown): value is { $$typeof: unknown } =>
  Boolean(value) && typeof value === 'object' && '$$typeof' in (value as Record<string, unknown>);

const ensureMessage = (message: unknown, fallback: string): ToastMessage => {
  if (message === null || message === undefined) return fallback;
  if (typeof message === 'string') {
    const trimmed = message.trim();
    return trimmed.length > 0 ? trimmed : fallback;
  }
  if (message instanceof Error) {
    const trimmed = message.message.trim();
    return trimmed.length > 0 ? trimmed : fallback;
  }
  if (isReactElement(message)) {
    return message as unknown as ToastMessage;
  }
  return fallback;
};

const baseToast = ((message?: ToastMessage, options?: ToastOptions) =>
  sonnerToast(ensureMessage(message, 'Notifica'), options)) as typeof sonnerToast;

const toast = Object.assign(baseToast, {
  success: (message?: ToastMessage, options?: ToastOptions) =>
    sonnerToast.success(ensureMessage(message, 'Operazione completata'), options),
  error: (message?: ToastMessage, options?: ToastOptions) =>
    sonnerToast.error(ensureMessage(message, 'Operazione non riuscita'), options),
  info: (message?: ToastMessage, options?: ToastOptions) =>
    sonnerToast.info(ensureMessage(message, 'Informazione'), options),
  warning: (message?: ToastMessage, options?: ToastOptions) =>
    sonnerToast.warning(ensureMessage(message, 'Attenzione'), options),
  loading: (message?: ToastMessage, options?: ToastOptions) =>
    sonnerToast.loading(ensureMessage(message, 'Caricamento...'), options),
  dismiss: (toastId?: string | number) => sonnerToast.dismiss(toastId),
});

export { toast };
